var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vueSeamlessScroll',{staticClass:"content",attrs:{"data":_vm.statusItems,"class-option":_vm.classOption}},_vm._l((_vm.statusItems),function(item,index){return _c('status-item',{key:index,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }